import React from 'react';
import { Row, Col } from 'react-bootstrap';

function BannerSection() {
  return (
    <section className='second section'>
      <div className="container simple-grid">
        <Row className="simple-grid-row">
          {/* Top Left: Experience */}
          <Col lg={7} md={12} className="simple-block experience-simple">
            <div className="exp-label-row">
              <span className="exp-number">25</span>
              <div className="exp-title-label-group">
                <span className="section-title">
                  <span className="split-underline-wrap">
                    <span className="split-underline">
                      <span className="split-underline-red">YE</span>AR OF EXPER
                    </span>
                  </span>IENCE
                </span>
                <span className="exp-industry-label">IN THIS INDUSTRY</span>
              </div>
            </div>
            <p className="section-desc">
              At Deepak Plywood & Timbers, we bring together premium quality materials, expert craftsmanship, and over a decade of experience to deliver products that stand the test of time. Whether you're working on a small home renovation or a large-scale construction project, our team is here to support your vision with top-tier materials, affordable solutions, and a commitment to excellence. From our award-winning quality to our dedicated service, we're more than a supplier; we're your partner in building something extraordinary.
            </p>
          </Col>
          {/* Top Right: Video */}
          <Col lg={5} md={12} className="simple-block video-simple">
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/60yzFTwoVjI"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </Col>
        </Row>
        <Row className="simple-grid-row">
          {/* Bottom Left: Images */}
          <Col lg={7} md={12} className="simple-block images-simple">
            <div className="images-container">
              <img
                src="/images/products/gallery26.jpg"
                alt="Sample Wood"
                style={{ width: '80%', height: 'auto', borderRadius: '8px', maxHeight: '315px', objectFit: 'cover', background: '#eee' }}
              />
            </div>
          </Col>
          {/* Bottom Right: Why Choose Us */}
          <Col lg={5} md={12} className="simple-block why-simple">
            <div className="why-title-row">
              <span className="section-title">
                <span className="split-underline-wrap">
                  <span className="split-underline">
                    <span className="split-underline-red">Wh</span>y choose
                  </span>
                </span> us
              </span>
            </div>
            <div className="section-desc">
              Choose us for unmatched quality and reliability. With over a decade of experience, we provide versatile, high-quality plywood solutions tailored to your needs
            </div>
            <div className="why-icons-grid">
              <div className="why-icon-item"><i className="fa fa-trophy"></i> Best Quality</div>
              <div className="why-icon-item"><i className="fa fa-users"></i> Expert team</div>
              <div className="why-icon-item"><i className="fa fa-briefcase"></i> Experienced</div>
              <div className="why-icon-item"><i className="fa fa-money"></i> Affordable services</div>
              <div className="why-icon-item"><i className="fa fa-certificate"></i> Award winning</div>
              <div className="why-icon-item"><i className="fa fa-refresh"></i> Warranty</div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}

export default BannerSection; 